import React from 'react';

import { FormattedMessage } from 'react-intl';
import Alert from '../Alert';

const HpaAlert = ({ name, message, values }) => {
  return (
    <Alert type={'hpa-' + values.hpaColor} className="text-center">
      <FormattedMessage
        id={message}
        values={{
          ...values,
          b: (chunks) => <b>{chunks}</b>,
        }}
      />
    </Alert>
  );
};

export default HpaAlert;
